<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.qnaClsManagement") }}</h4>
    </div>
    <div class="commTop_btn_wrap p-2" style="text-align: right">
      <router-link
        to="/management/support/qna/cls/form"
        class="btn btn-primary btn-md m-2"
        >{{ $t("common.add") }}</router-link
      >
      <a href="#" @click="showQaModal" class="btn btn-secondary btn-md">{{
        $t("common.changeOrder")
      }}</a>
    </div>

    <table summary="" class="list_tbl">
      <thead>
        <tr>
          <th class="mobile_row w-25">{{ $t("common.classify") }}</th>
          <th class="mobile_h w-25">{{ $t("common.clsDetail") }}</th>
          <th class="mobile_h w-25">{{ $t("common.writer") }}</th>
          <th class="mobile_h w-25">{{ $t("common.date") }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-if="items">
        <tr v-for="(item, index) in items" :key="index">
          <td class="subject text-left">
            <router-link
              :to="{ name: 'mgmtQnaClsForm', params: { classId: item.classId } }"
              >{{ item.className }}</router-link
            >
          </td>
          <td class="text-left">
            <router-link
              :to="{ name: 'mgmtQnaClsForm', params: { classId: item.classId } }"
              >{{ item.classDesc }}</router-link
            >
          </td>
          <td>
            <router-link
              :to="{ name: 'mgmtQnaClsForm', params: { classId: item.classId } }"
              >{{ item.lastModrName }}</router-link
            >
          </td>
          <td>
            <router-link
              :to="{ name: 'mgmtQnaClsForm', params: { classId: item.classId } }"
              >{{ item.lastModDateTime }}</router-link
            >
          </td>
          <td>
            <button @click="deleteQnaCls(item.classId)" class="btn btn-primary btn-md">
              {{ $t("common.delete") }}
            </button>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="5">{{ $t("common.noData") }}</td>
        </tr>
      </tbody>
    </table>

    <CommonModal id="qaClsModal" v-if="showModal" @close="showModal == false">
      <template slot="header">
        <h3>{{ $t("common.changeOrder") }}</h3>
      </template>
      <template slot="body">
        <table class="list_tbl">
          <thead>
            <tr>
              <th class="mobile_row w-25">{{ $t("common.classify") }}</th>
              <th class="mobile_h w-25">{{ $t("common.clsDetail") }}</th>
              <th class="mobile_h w-25">{{ $t("common.writer") }}</th>
              <th class="mobile_h w-25">{{ $t("common.date") }}</th>
            </tr>
          </thead>
          <draggable v-model="items" tag="tbody">
            <tr v-for="item in items" :key="item.sort">
              <td class="w-25 text-left">{{ item.className }}</td>
              <td class="w-25 text-left">{{ item.classDesc }}</td>
              <td class="w-25">{{ item.lastModrName }}</td>
              <td class="w-25">{{ item.lastModDateTime }}</td>
            </tr>
          </draggable>
        </table>
      </template>
      <template slot="footer">
        <button type="button" @click="saveNewSort" class="btn btn-primary">
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </CommonModal>
  </section>
</template>

<script>
import { getQnaClsList, deleteQnaCls, saveNewQaClsSort } from "@/api/qna";
import CommonModal from "@/components/modal/CommonModal";
import draggable from "vuedraggable";
export default {
  components: {
    CommonModal,
    draggable,
  },
  data() {
    return {
      active: false,
      items: [],
      classList: [],
      qnaCls: {},
      confirmYN: false,
      showModal: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    // 분류조회
    async fetchData() {
      try {
        const response = await getQnaClsList();
        this.items = response.data.qaClsList;
      } catch (err) {
        console.log(err);
      }
    },
    // 분류 삭제
    async deleteQnaCls(classId) {
      this.confirmYN = confirm(this.$t("alert.delete"));
      if (this.confirmYN) {
        try {
          const { data } = await deleteQnaCls(classId);
          if (data.status) {
            this.fetchData();
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    showQaModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    checkMove() {},
    async saveNewSort() {
      this.conformYN = confirm(this.$t("alert.save"));
      if (this.conformYN) {
        try {
          const { data } = await saveNewQaClsSort(this.items);
          if (data.status) {
            this.showModal = false;
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        return;
      }
    },
  },
};
</script>

<style></style>
